import React from 'react';
import { gql, useQuery } from '@apollo/client';
import client from './GraphQLCustomClientFactory';

const GET_ITEM_BY_PATH = gql`
  query GetItemByPath($path: String!, $language: String!) {
    item(path: $path, language: $language) {
      fields {
        name
        value
      }
    }
  }
`;

export function useGetSitecoreFields(path, fieldNames = [], language = 'en', enabled = true) {
  // Check if we're in a browser environment to prevent SSR execution
  const isBrowser = typeof window !== 'undefined';

  const { data, loading, error } = useQuery(GET_ITEM_BY_PATH, {
    client,
    variables: { path, language },
    skip: !enabled || !isBrowser, // Skip during SSR
    fetchPolicy: 'no-cache',
  });

  const values = React.useMemo(() => {
    if (!data?.item?.fields) return {};

    const fieldsMap = {};
    for (const fieldName of fieldNames) {
      const field = data.item.fields.find((f) => f.name === fieldName);
      fieldsMap[fieldName] = field ? field.value : null;
    }
    return fieldsMap;
  }, [data, fieldNames]);

  // During SSR, return safe defaults
  if (!isBrowser) {
    return {
      values: {},
      loading: false,
      error: null,
    };
  }

  return { values, loading, error };
}
